document.addEventListener('DOMContentLoaded', function () {
  var lazyVideos = [].slice.call(document.querySelectorAll('video.lazy-video'))
  if ('IntersectionObserver' in window) {
    var lazyVideoObserver = new IntersectionObserver((entries, observer) => {
      entries.forEach((video) => {
        if (video.isIntersecting) {
          for (var source in video.target.children) {
            var videoSource = video.target.children[source]
            if (typeof videoSource.tagName === 'string' && videoSource.tagName === 'SOURCE') {
              videoSource.src = videoSource.dataset.videoSrc
            }
          }
          video.target.load()
          video.target.classList.remove('lazy-video')
          lazyVideoObserver.unobserve(video.target)
        }
      })
    })

    lazyVideos.forEach(function (lazyVideo) {
      lazyVideoObserver.observe(lazyVideo)
    })
  }
})

if (!customElements.get('video-element')) {
  class VideoElement extends HTMLElement {
    constructor() {
      super()

      // Default options
      this.defaultOptions = {
        videoId: '',
        videoType: '',
        autoplay: false,
      }
      this.dataOptions = {}

      // Get options from element data and combine with default options
      if (this?.dataset.options) {
        this.dataOptions = JSON.parse(this.dataset.options)
      }
      this.options = {
        ...this.defaultOptions,
        ...this.dataOptions,
      }

      this.videoId = this.options.videoId
      this.videoType = this.options.videoType
      this.videoOverlay = this.querySelector('[data-video-overlay]')
      this.videoControls = this.querySelector('[data-video-controls]')
      this.playButtons = this.querySelectorAll('[data-video-play-button]')
      this.activeClass = 'is-video-active'
      this.loadingClass = 'is-video-loading'
      this.hiddenClass = 'hidden'
      this.allowAutoplay = true

      if (typeof Vimeo !== 'undefined') {
        this.vimeoPlayer = new Vimeo.Player(`video-${this.videoType}_${this.videoId}`, { autoplay: false, muted: this.options.autoplay })
        this.bindVimeoEvents()

        if (this.options.autoplay) {
          document.body.click()
          this.handleScroll()
        }
      }
    }

    /**
     * Bind Vimeo elements
     */
    bindVimeoEvents() {
      const self = this

      // Custom play buttons/areas
      this.playButtons.forEach((btn) =>
        btn.addEventListener('click', (event) => {
          event.preventDefault()
          event.stopPropagation()
          self.classList.add(self.loadingClass)
          self.vimeoPlayer.play()
        }),
      )
      this.videoControls.addEventListener('click', (event) => {
        event.stopPropagation()
        self.classList.remove(self.activeClass)
        self.vimeoPlayer.play()
      })

      // When video is playing
      self.vimeoPlayer.on('play', function () {
        self.classList.add(self.activeClass)
        self.classList.remove(self.loadingClass)
        self.videoOverlay.classList.add(self.hiddenClass)
        self.videoControls.classList.add(self.hiddenClass)
      })

      // When video is paused
      self.vimeoPlayer.on('pause', function () {
        self.allowAutoplay = false
        self.classList.remove(self.loadingClass)
        self.videoOverlay.classList.remove(self.hiddenClass)
        self.videoControls.classList.remove(self.hiddenClass)
      })
    }

    /**
     * Handle scroll
     */
    handleScroll() {
      const self = this
      let isInView

      document.addEventListener('scroll', function () {
        isInView = self.isElementInView(self)

        if (isInView && self.allowAutoplay) {
          self.classList.remove(self.activeClass)

          self.vimeoPlayer.getPaused().then((paused) => {
            if (paused) {
              self.vimeoPlayer.play()
            }
          })
        }
      })
    }

    /**
     * Get element position
     * @return boolean
     */
    isElementInView(el) {
      const rect = el.getBoundingClientRect()

      // Guard for hidden elements
      if (window.getComputedStyle(el).display === 'none') {
        return false
      }

      return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <= (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
      )
    }
  }

  window.VideoElement = VideoElement
  customElements.define('video-element', VideoElement)
}
